var React = require('react');

function GraphBar (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 1a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2V3a2 2 0 00-2-2H3zm2 5H3v5h2V6zm1 2h2v3H6V8zm5-5H9v8h2V3z","fill":"currentColor"}));
}

GraphBar.defaultProps = {"fill":"none","viewBox":"0 0 15 15"};

module.exports = GraphBar;

GraphBar.default = GraphBar;
